export default "__VITE_ASSET__BEFpvEOY__"